import * as fb from '../../firebase'
import * as firebase from 'firebase/app'
import dateHelper from '@/helpers/dateHelper'

const state = {
  currentCategoryTargets:{},
  targets: {},
  targetslist:{},
  categories:['weekly', 'monthly', 'quarterly']
}

/* ================================================================ */
const mutations = {
  updateCurrentCategoryTargets(state, payload) {
    if (payload.from && payload.category) {
      state.currentCategoryTargets = {
        from: payload.from,
        to: payload.to,
        category: payload.category
      }
    }
    else if(payload.targets) {
      state.currentCategoryTargets['targets']=payload.targets
    }
  },
  //{start: 2020-10-01, targets:[{...}, {...}]}
  setTargets(state, payload) {
    state['targets'] = payload
  },

  //{from: '2020-10-20', to: '2020-10-27', targets:[{...}, {...}]}
  setCategoryTargets(state, payload) {
    state['targets'][payload.category] = {
      from: payload.from,
      to: payload.to,
      targets: payload.targets
    }
  },
  /**
   * Add all the targetslit 
   * {'weekly':[...], 'monthly':[...], 'quarterly': [...]}
   */
  setTargetsList(state, payload) {
    state.targetslist= payload;
  },
  /**
   * Add new target (weekly, monthly or quarterly) to targetslist
   */
  updateTargetsList(state, payload) {
    if (! Array.isArray(state.targetslist[payload.category])) {
      state.targetslist[payload.category] = [];
    }
    //check if new items is already present
    const found = state.targetslist[payload.category].find(item => item.from == payload.from)
    if (!found) {
      state.targetslist[payload.category].push(
        { from: payload['from'], to: payload['to']})
    }
  },

  deleteFromTargetsList(state, payload) {
    if (!Array.isArray(state.targetslist[payload.category])) return;
    console.log('About to delete item from targetslist')
    state.targetslist[payload.category]= state.targetslist[payload.category].filter(item => item.from != payload.from);
  }

}

/* ================================================================ */
const actions = {
  initCurrentCategoryTargets({commit}, payload) {
    commit('updateCurrentCategoryTargets', payload)
  },
  //
  async fetchCurrentCategoryTargets({ commit }, payload) {
    await fb.targetsCollection.doc(fb.auth.currentUser.uid).collection('targets').doc(payload['category'] + '-' + payload['from']).get()
      .then((doc) => {
        if (doc.exists && doc.data()) {
          commit('updateCurrentCategoryTargets', doc.data())
        }
        else {
          console.log('No category targets found')
        }
      }).catch(error => {
      console.log('Error fetching current category target', error.message)
    })
    
  },
  //
  async saveUploadTargets({commit, dispatch }, payload) {
    await fb.targetsCollection.doc(fb.auth.currentUser.uid).collection('targets').doc(payload['category'] + '-' + payload['from']).set({ 'targets': payload['targets'] }, { merge: true })
      .then(() => {
        commit('setCategoryTargets', payload) 
        dispatch('saveTargetsList', { category: payload['category'], from: payload['from'], to: payload['to'] })
      }).catch(error => {
        throw (error)
      });
  },
  //
  async fetchTargets({ commit}, payload) {
    await fb.targetsCollection.doc(fb.auth.currentUser.uid).collection('targets').where(firebase.firestore.FieldPath.documentId(), 'in', payload['docs']).get()
      .then((querySnapshot) => {
        const loadedItems = {}
        var from, to;
        querySnapshot.forEach(function (doc) {
          var [category, year, month, date] = doc.id.split('-')
          from = `${year}-${month}-${date}`
          to = dateHelper.getLastDay(category, from);
          loadedItems[category]={from, to, targets:doc.data()['targets']}
        });

        commit('setTargets', loadedItems)
      })
      .catch(error => {
        console.log('Error while fetching targets:', error)
      })
  },
  //
  async saveTargetsList({ state, commit, dispatch }, payload) {
    //Whether targetslist collection already fetched
    if (Object.keys(state.targetslist).length > 0) {
      dispatch('updateTargetsList', {category: payload['category'], from: payload['from'], to: payload['to']})
    }
    else {
      await fb.targetsCollection.doc(fb.auth.currentUser.uid).collection('targets').doc('targetslist').get().then( async (doc) => {
         
        if (!doc.exists) {
          dispatch('createTargetsList', payload)
        }
        else {
          //Save targets list already retrieved
          commit('setTargetsList', doc.data())
          //
          dispatch('updateTargetsList', {category: payload['category'], from: payload['from'], to: payload['to']})
        }
      });
    }
  },
  //
  async createTargetsList({ commit }, payload) {
    console.log('Creating a new targetslist')

    await fb.targetsCollection.doc(fb.auth.currentUser.uid).collection('targets').doc('targetslist').set({
      [payload.category]: [{ from: payload.from, to: payload.to }]
    })
      .then(() => {
        commit('updateTargetsList', payload)
      })
      .catch(error => {
        console.log('Error:', error)
      })
  },
  //
  async updateTargetsList({ commit }, payload) {
    console.log('Updating targetslist')
    await fb.targetsCollection.doc(fb.auth.currentUser.uid).collection('targets').doc('targetslist').update({
      [payload.category]: firebase.firestore.FieldValue.arrayUnion({ from: payload.from, to: payload.to })
    })
      .then(() => {
        commit('updateTargetsList', payload)
      })
      .catch(error => {
        console.log('Error:', error)
      })
  },
  //
  async fetchTargetsList({state, commit }) {
    if (Object.keys(state.targetslist).length > 0) { return; }
    
    await fb.targetsCollection.doc(fb.auth.currentUser.uid).collection('targets').doc('targetslist').get().then(doc => {

      const payload=doc.data() ? doc.data(): {}
      commit('setTargetsList', payload)
    }).catch(error => {
      console.log('Error:', error)
    })
  },
  //
  async deleteCategoryTargets({commit, dispatch }, payload) {
    await fb.targetsCollection.doc(fb.auth.currentUser.uid).collection('targets').doc(payload['category'] + '-' + payload['from']).delete()
      .then(() => {
        commit('deleteFromTargetsList', payload)
        dispatch('deleteTargetsListItem', payload)
      }).catch(error => {
      console.log('Error while deleting document', payload['category'] + '-' + payload['from'], ':', error)
    })
  },
  //
  async deleteTargetsListItem({state, commit }, payload) {
    const targets = state.targetslist[payload.category].filter(item => item.from != payload.from)
    
    await fb.targetsCollection.doc(fb.auth.currentUser.uid).collection('targets').doc('targetslist').update({[payload.category]: targets})
      .then(() => {
        commit('deleteFromTargetsList', payload)
      }).catch(error => {
        console.log('Error while deleting targetslist item', payload['category'] + '=>' + payload['from'], ':', error)
      })

  }
}



/* ================================================================ */
const getters={
  getUniqueID (){
    return (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toLowerCase();
  },

  getDateSpan: (state, getters) => (category, date) =>{
    date= date || getters.getDisplayDate()
    const from = getters.getFirstDay(category, date);
    const to = getters.getLastDay(category, date);

    return {from, to}
  },
  //Split display targetDate into integer parts
  getDateParts:() => targetDate => {
    var [year, month, date] = targetDate.split('-');
    year = parseInt(year);
    month = parseInt(month) - 1;
    date = parseInt(date);

    return [year, month, date];
  }, 
  //
  getFirstDay: (state, getters) => ( category, targetDate) => {
    var [year, month, date] = getters.getDateParts(targetDate);
    if (category == 'weekly') {
      return getters.getFirstDayOfWeek(year, month, date) 
    }
    else if (category == 'monthly') {
      return getters.getFirstDayOfMonth(year, month)
    }
    else if (category == 'quarterly') {
      return getters.getFirstDayOfQuarter(year, month)
    }
    
  },
  //
  getLastDay: (state, getters) => ( category, targetDate) =>{
    var [year, month, date] = getters.getDateParts(targetDate);

    if (category == 'weekly') {
      return getters.getLastDayOfWeek(year, month, date) 
    }
    else if (category == 'monthly') {
      return getters.getLastDayOfMonth(year, month)
    }
    else if (category == 'quarterly') {
      return getters.getLastDayOfQuarter(year, month)
    }
    
  },
  //month: 1-12
  getFirstDayOfWeek: (state, getters) => ( year, month, date) => {
    const curDate = new Date(year, month, date);
    //Day of the week: 0 - 6
    var day = curDate.getDay();
    //ISO Standard first day of the week is Monday +1
    var from = date - day + 1;

    if (from > 0) {
      return getters.getDisplayDate(year, month, from);
    }
  
    //Month 0 - 11
    if (month > 1) {
      month -= 1;
    }
    else {
      //December of Previous year
      month = 11;
      year -= 1;
    }

    const ndays = getters.getNumberOfDays(year, month);
    from = ndays + from;

    return getters.getDisplayDate(year, month, from);
  },
  //
  getLastDayOfWeek: (state, getters) => (year, month, date) => {
    const curDate = new Date(year, month, date);
    const ndays = getters.getNumberOfDays(year, month);
    //ISO Standard last day of the week is Sunday +0
    //Day of the week: 0 - 6
    var day = curDate.getDay();
    //Date of end of week
    var to = date - day + 7;

    //We are still in same month of current year
    if (to <= ndays) {
      return getters.getDisplayDate(year, month, to);
    }

    //Not December of current year
    if (month < 11) {
      month += 1;
    }
    else {
      //January next year
      month = 0;
      year += 1;
    }

    to = to - ndays;

    return getters.getDisplayDate(year, month, to);
  },
  //
  getFirstDayOfMonth: (state, getters) => ( year, month) => {
    return getters.getDisplayDate(year, month, 1);
  },
  //
  getLastDayOfMonth: (state, getters) => ( year, month) => {
    const ndays=getters.getNumberOfDays(year, month)
    
    return getters.getDisplayDate(year, month, ndays);
  },
  //
  getFirstDayOfQuarter: (state, getters) => (year, month) => {
    const firstMonth = Math.floor(month / 3) * 3;
    return  getters.getDisplayDate(year, firstMonth, 1)
  },
  //
  getLastDayOfQuarter: (state, getters) => ( year, month) => {
    var lastMonth=Math.floor(month / 3) * 3 + 2;
    var lastDay=(month>=3 && month<9)? 30: 31;

    return getters.getDisplayDate ( year, lastMonth, lastDay);
  },
  //
  getNumberOfDays: () => ( year, month) => {
    const isLeapYear = ((year % 4) == 0) ? true : false;
    const isEven = (month % 2) ? false : true;

    //February
    if (month == 1) {
      return isLeapYear ? 29 : 28;
    }
    else if ((isEven && month < 7) || (!isEven && month >= 7)) {
      return 31;
    }

    return 30;
  },
  //
  getDisplayDate: () => ( year, month, date) => {

    if(isNaN(year) || isNaN(month) || isNaN(date)) {
      const curDate = new Date();
      year = curDate.getFullYear();
      //getMonth returns an Integer: 0-11
      month = curDate.getMonth();
      date = curDate.getDate();
    }

    month = (parseInt(month) + 1).toString().padStart(2, '0');
    date = parseInt(date).toString().padStart(2, '0');

    return year + '-' + month + '-' + date;
  },

}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}